// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*.border-bottom {\n  border-color: rgba(197, 197, 197, 0.925);\n  border-bottom-style: solid;\n  border-width: 0.5px;\n}\n.p-0 {\n  padding: 0;\n}\n.py-2 {\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n.px-3 {\n  padding-right: 12px !important;\n  padding-left: 12px !important\n}*/\n", ""]);
// Exports
module.exports = exports;
